import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
@Injectable()
export class OverallTemperatureAdheranceService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getOverallTemperatureAdherance(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: url, // "./assets/data/p-d-otiftrends.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processOverallTemperatureAdherance)
    );
  }
  processOverallTemperatureAdherance(data: any) {
    const percentage = [];
    const labels = data.map(value => {
      const aDate = new Date(value.date);
      percentage.push(value.percentage);
      return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
    });

    return { labels, percentage };
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.xAxis[0].categories = chartData.labels;

    chart.series[0].data = chartData.percentage;
    chart.series[0].name = Options.yaxis;
    chart.yAxis.title.text = Options.yaxis;

    return chart;
  }
}
